import { createContext, useContext } from 'react';

export const SmartQuoteContext = createContext<string[]>([]);

export function useIsAiGeneratedField(fieldId: string) {
  const aiGeneratedFields = useContext(SmartQuoteContext);
  return aiGeneratedFields.includes(fieldId);
}
